import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const validRoutes = [
  "/", "/payments", "/loans", "/insurance", "/about-us", "/why-us", "/culture", "/careers",
  "/contact-us", "/personal-loan", "/customer-services", "/sentinel", "/sitemap",
  "/newsroom", "/partners", "/privacy-policies", "/privacy-policy-akara", "/terms-and-conditions",
  "/grievance-mechanism", "/Akara_Interest_Rate_Policy.pdf", "/certificate.2b40088e8d1e870f3f11.pdf",
  "/website-disclosure", "/Data_Retention_Policy__.pdf"
];

const MAIN_DOMAIN = "https://stashfin.com";

const RouteRedirector = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    if (validRoutes.includes(currentPath)) {
      const fullURL = `${MAIN_DOMAIN}${currentPath}${location.search}${location.hash}`;
      window.location.replace(fullURL);
    }
  }, [location]);

  return <>{children}</>;
};

export default RouteRedirector;
